import { createSignal } from "solid-js";
import { signalExtender } from "../../../utils/signal.js";
function createDeepObject(value, options) {
    return createDeepObject.wrap(createSignal(value, options));
}
createDeepObject.wrap = (signal) => {
    return signalExtender(signal).extend(([state, setState]) => [
        {},
        {
            deep: (function deep(path = []) {
                return new Proxy(() => { }, {
                    apply(_target, _this, [setStateAction]) {
                        const value = typeof setStateAction === "function"
                            ? setStateAction(state())
                            : setStateAction;
                        setState((function nextValue(current = state(), i = 0) {
                            if (i === path.length)
                                return value;
                            return {
                                ...current,
                                [path[i]]: nextValue(current[path[i]], i + 1),
                            };
                        })());
                        return value;
                    },
                    get: (_target, prop) => deep([...path, prop]),
                    has: () => true,
                });
            })(),
        },
    ]);
};
export default createDeepObject;
